// 404 Page
export const emptyBG = require('./misc/404-img.png');

// Home Page
export const sampleBanner = require('./home/sample_banner.jpg');
export const sampleIntro1 = require('./home/sample_intro_1.jpg');
export const sampleIntro2 = require('./home/sample_intro_2.jpg');
export const sampleIntro3 = require('./home/sample_intro_3.jpg');

// Forgot Password
export const resetPw = require('./forgot_password/reset_pw.png');

// Misc
export const companyLogo = require('./misc/logo.png');
export const profilePlaceholder = require('./misc/profile-placeholder.png');

// SVG Icon
export const searchIcon = require('./svg/search.svg');
export const cartIcon = require('./svg/cart.svg');
export const checkIcon = require('./svg/check.svg');
export const checkIconW = require('./svg/check-w.svg');
export const profileIcon = require('./svg/profile.svg');
export const removeIcon = require('./svg/remove.svg');
export const dropdownIcon = require('./misc/dropdown-black.png');
export const dropdownIconW = require('./misc/dropdown-white.png');


// WEBPACK FOOTER //
// ./src/resources/images/index.js